import { WarningCircleIcon } from '@phosphor-icons/react';

import { Button } from '@/components/common/button';

import styles from './error-state.module.scss';

export type ErrorStateProps = {
  title?: string;
  description?: string;
  /** When provided, renders a Retry button. */
  onRetry?: () => void;
  retryText?: string;
  className?: string;
};

/** Centered load-failure placeholder with an optional retry. */
export function ErrorState({
  title = 'Something went wrong',
  description = 'Please try again.',
  onRetry,
  retryText = 'Retry',
  className,
}: ErrorStateProps) {
  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')} role="alert">
      <WarningCircleIcon size={48} weight="duotone" className={styles.icon} />
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
      {onRetry ? (
        <Button variant="outline" onClick={onRetry}>
          {retryText}
        </Button>
      ) : null}
    </div>
  );
}
